import axiosInstance from './axios.config';

const BASE_URL = '/locations';

export const locationAPI = {
    /**
     * Get all regions
     */
    getAllRegions: async () => {
        try {
            const response = await axiosInstance.get(`${BASE_URL}/regions`);
            return response.data;
        } catch (error) {
            console.error('Get regions error:', error);
            throw error;
        }
    },

    /**
     * Get districts by region ID
     */
    getDistrictsByRegion: async (regionId) => {
        try {
            const response = await axiosInstance.get(`${BASE_URL}/regions/${regionId}/districts`);
            return response.data;
        } catch (error) {
            console.error('Get districts error:', error);
            throw error;
        }
    },

    /**
     * Get all districts
     */
    getAllDistricts: async () => {
        try {
            const response = await axiosInstance.get(`${BASE_URL}/districts`);
            return response.data;
        } catch (error) {
            console.error('Get all districts error:', error);
            throw error;
        }
    },
};

